var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn num-btn",attrs:{"id":"NUMBER_8","name":"8","data-vcode":"NUMBER_8","aria-label":"8 TUV"}},[_c('div',{staticClass:"digit"},[_vm._v("8")]),_c('div',{staticClass:"letters"},[_vm._v("TUV")])])
}]

export { render, staticRenderFns }